import { combineReducers } from "redux";
import { AcSeatCfgModalReducer } from "./acSeatCfgModalReducer";
import { dashboardFilterCriteriaReducer } from "./dashboardFilterCriteria.reducer";
import { EsoCommonReducer } from "./EsoCommonReducer";
import { ImportOrderSearchReducer } from "./ImportOrderSearchReducer";
import { PaxSearchRuleReducer } from "./PaxSearchRuleReducer";
import { PollingPoliciesReducer } from "./PollingPoliciesReducer";
import { ServiceOrderQueryCriteriaReducer } from "./ServiceOrderQueryCriteriaReducer";
import { SmartOrderDashboardReducer } from "./SmartOrderDashboardReducer";
import { SoDashboardJobHistoryReducer } from "./SoDashboardJobHistoryReducer";
import { TopFocusItemsReducer } from "./TopFocusItemsReducer";

const appEsoReducer = combineReducers({
  EsoCommonReducer,
  dashboardFilterCriteriaReducer,
  AcSeatCfgModalReducer,
  PaxSearchRuleReducer,
  PollingPoliciesReducer,
  SoDashboardJobHistoryReducer,
  ServiceOrderQueryCriteriaReducer,
  TopFocusItemsReducer,
  SmartOrderDashboardReducer,
  ImportOrderSearchReducer,
});

export function EsoReducer(state, action) {
  switch (action.type) {
    case "RESET_REDUX": {
      console.log("RESET_REDUX EsoReducer");
      return appEsoReducer(undefined, action);
    }
    default:
      return appEsoReducer(state, action);
  }
}
